import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "CasinoSecondaryNavigation" */ './CasinoSecondaryNavigation'),
  modules: ['./CasinoSecondaryNavigation'],
  loading: () => <div />
});

export default LoadableWidget;
